import { ref } from "vue";
import User from '@/utils/User';
import { TypeFluxFormat } from '@/utils/constant/settings_constantes';
import { getServerConfig } from "@/utils/serverConfig";

export default class Map_Imagery {
  viewer;
  datasource;
  basemapImagery;

  constructor(viewer) {
    this.viewer = viewer;

    this.init();
  }

  async init() {
    // await $root.user.getSettings();
    const serverConfig = await getServerConfig();
      this.basemapImagery = serverConfig.basemap;
      this.imageryKeySelected = Object.keys(this.basemapImagery)[0];
      this.addImageries();
      this.changeFondDeCarte(this.imageryKeySelected);
      this.applyImagerySettings();
  }


  addImageries() {
    // Ajout des imagery default
    Object.keys(this.basemapImagery).forEach((key) => {
      const basemap = this.basemapImagery[key];
      if (basemap.type === "osm") {
        let imagery_osm = new Cesium.OpenStreetMapImageryProvider();
        let imageryLayer = this.viewer.imageryLayers.addImageryProvider(imagery_osm);
        imageryLayer.show = false;
        imageryLayer.name = key;
      } else if (basemap.type === "ion" && !isNaN(parseInt(basemap.ionid))) {
        let imagery_ion = Cesium.ImageryLayer.fromProviderAsync(
          Cesium.IonImageryProvider.fromAssetId(basemap.ionid)
        );
        this.viewer.imageryLayers.add(imagery_ion);
        imagery_ion.show = false;
        imagery_ion.name = key;
      } else if (basemap.type === "wms") {
        let imagery_wms = new Cesium.WebMapServiceImageryProvider({
          url: basemap.url,
          layers: basemap.layers,
          parameters: basemap.parameters || {}
        });
        let imageryLayer = this.viewer.imageryLayers.addImageryProvider(imagery_wms);
        imageryLayer.show = false;
        imageryLayer.name = key;
      } else if (basemap.type === "wmts") {
        let imagery_wmts = new Cesium.WebMapTileServiceImageryProvider({
          url: basemap.url,
          layer: basemap.layer,
          style: basemap.style,
          format: basemap.format,
          tileMatrixSetID: basemap.tileMatrixSetID,
          maximumLevel: basemap.maximumLevel
        });
        let imageryLayer = this.viewer.imageryLayers.addImageryProvider(imagery_wmts);
        imageryLayer.show = false;
        imageryLayer.name = key;
      }
    });


    // Ajout des custom maps
    const customMaps = $root.user.getSettingsCustomMap();
    Object.keys(customMaps).forEach((key)=>{
      this.createImageryProvider(customMaps[key]);
    });
  }

  applyImagerySettings(keyMap) {
    for( let i=0; i <this.viewer.imageryLayers.length; i++) {
      let imageryLayer = this.viewer.imageryLayers.get(i);
      if(keyMap !== undefined && keyMap !== null && keyMap !==""){
        if(imageryLayer.name !== undefined && imageryLayer.name === keyMap){
          imageryLayer.hue = $root.user.getSettingsHue();
          imageryLayer.contrast = $root.user.getSettingsContrast();
          imageryLayer.gamma = $root.user.getSettingsGamma();
          imageryLayer.saturation = $root.user.getSettingsSaturation();
          imageryLayer.brightness= $root.user.getSettingsBrightness();

          break;
        }
      }
      else{
        imageryLayer.hue = $root.user.getSettingsHue();
        imageryLayer.contrast = $root.user.getSettingsContrast();
        imageryLayer.gamma = $root.user.getSettingsGamma();
        imageryLayer.saturation = $root.user.getSettingsSaturation();
        imageryLayer.brightness= $root.user.getSettingsBrightness();
      }
    }
  }

  changeFondDeCarte(keyMap){
    if (keyMap === undefined || keyMap === null || keyMap === "") {
      return;
    }
    for( let i=0; i <this.viewer.imageryLayers.length; i++) {
      let imageryLayer = this.viewer.imageryLayers.get(i);
      if(imageryLayer.name != undefined) {
        this.imageryKeySelected = keyMap;
        imageryLayer.show = imageryLayer.name === keyMap;
      }
    }
  }



  updateImageryProvider(configMap){
    let found = false;
    for( let i=0; i <this.viewer.imageryLayers.length; i++) {
      let imageryLayer = this.viewer.imageryLayers.get(i);
      if(imageryLayer.name != undefined && imageryLayer.name === configMap.key) {
        found = true;
        // on supprime l'ancienne version du layer
        this.viewer.imageryLayers.remove(imageryLayer);
        // on en recrée un avec la nouvelle config
        const result = this.createImageryProvider(configMap);
        // on applique la visibilité de l'ancienne couche
        result.layer.show = imageryLayer.show;

        return result;
      }
    }

    // Cas où formulaire édition ouvert, et que la carte est suppr en parallèle
    return {success: false , msg : {message: "La carte en cours d'édition n'existe plus."}};
  }

  createImageryProvider(configMap){
    if( configMap.typeflux === "wms" ){
      try{
        let layer = new Cesium.WebMapServiceImageryProvider({
          url: configMap.url,
          layers: configMap.layers,
          parameters: {
            transparent: "true",
            format: "image/png",
          },
        });
        let imageryLayer = this.viewer.imageryLayers.addImageryProvider(layer);
        imageryLayer.name = configMap.key;
        imageryLayer.show = false;
        // this.imageries_provider.value.push(imageryLayer);

        return {success:true, msg:'', layer : imageryLayer};
      }
      catch(err){
        return {success:false, msg:err};
      }
    }
    else  if( configMap.typeflux === "wmts" ){
      try{
        let layer = new Cesium.WebMapTileServiceImageryProvider({
          url: configMap.url,
          layer: configMap.layer,
          style: configMap.style,
          format : this.getImageryFormatFromKey(configMap.typeformat),
          tileMatrixSetID : configMap.tileMatrixSetID !== undefined && configMap.tileMatrixSetID !== null && configMap.tileMatrixSetID !== "" ? configMap.tileMatrixSetID : ""

        });
        let imageryLayer = this.viewer.imageryLayers.addImageryProvider(layer);
        imageryLayer.name = configMap.key;
        imageryLayer.show = false;
        // this.imageries_provider.value.push(imageryLayer);

        return {success:true, msg:'', layer : imageryLayer};
      }
      catch(err){
        return {success:false, msg:err};
      }
    }
  }

  deleteImageryProvider(keyMap){
    for( let i=0; i <this.viewer.imageryLayers.length; i++) {
      let imageryLayer = this.viewer.imageryLayers.get(i);
      if(imageryLayer.name != undefined && imageryLayer.name === keyMap) {
        // on supprime la couche de la liste des imageryLayer
        this.viewer.imageryLayers.remove(imageryLayer);

        break;
      }
    }

    // si on delete la couche actueullement active => rebascule sur Sat
    if(keyMap === this.imageryKeySelected){
      this.changeFondDeCarte(Object.keys(this.basemapImagery)[0]);
    }
  }

  getImageryFormatFromKey(key) {

    let format = "";
    TypeFluxFormat.forEach(f => {
      if(f.key == key){
        format = f.displayname;
      }
    });
    return format;
  }
}
